import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withModifiers as _withModifiers, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "photo-gallery" }
const _hoisted_2 = { class: "gallery-header" }
const _hoisted_3 = { class: "gallery-title-section" }
const _hoisted_4 = { class: "gallery-title" }
const _hoisted_5 = {
  key: 0,
  class: "gallery-subtitle"
}
const _hoisted_6 = { class: "gallery-actions" }
const _hoisted_7 = {
  key: 1,
  class: "stats-section"
}
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = { class: "stat-number" }
const _hoisted_10 = { class: "stat-label" }
const _hoisted_11 = { class: "stat-card" }
const _hoisted_12 = { class: "stat-number" }
const _hoisted_13 = { class: "stat-label" }
const _hoisted_14 = { class: "stat-card" }
const _hoisted_15 = { class: "stat-number" }
const _hoisted_16 = { class: "stat-label" }
const _hoisted_17 = { class: "stat-card" }
const _hoisted_18 = { class: "stat-number" }
const _hoisted_19 = { class: "stat-label" }
const _hoisted_20 = {
  key: 2,
  class: "controls-section"
}
const _hoisted_21 = { class: "controls-row" }
const _hoisted_22 = { class: "search-bar" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "view-controls" }
const _hoisted_25 = { class: "view-toggle" }
const _hoisted_26 = ["title"]
const _hoisted_27 = ["title"]
const _hoisted_28 = ["title"]
const _hoisted_29 = { value: "newest" }
const _hoisted_30 = { value: "oldest" }
const _hoisted_31 = { value: "name-asc" }
const _hoisted_32 = { value: "name-desc" }
const _hoisted_33 = { class: "filter-section" }
const _hoisted_34 = { class: "filter-tags" }
const _hoisted_35 = { class: "filter-label" }
const _hoisted_36 = { class: "tag-count" }
const _hoisted_37 = { class: "tag-count" }
const _hoisted_38 = { class: "tag-count" }
const _hoisted_39 = {
  key: 0,
  class: "pagination-controls pagination-top"
}
const _hoisted_40 = { class: "pagination-info" }
const _hoisted_41 = { class: "pagination-buttons" }
const _hoisted_42 = ["disabled", "title"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["disabled", "title"]
const _hoisted_45 = {
  key: 3,
  class: "gallery-loading"
}
const _hoisted_46 = { class: "skeleton-container" }
const _hoisted_47 = {
  key: 4,
  class: "gallery-empty"
}
const _hoisted_48 = { class: "empty-title" }
const _hoisted_49 = { class: "empty-description" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "photo-card-image" }
const _hoisted_52 = ["src", "alt", "onLoad", "onError"]
const _hoisted_53 = ["src", "onLoadeddata", "onError"]
const _hoisted_54 = {
  key: 2,
  class: "video-badge"
}
const _hoisted_55 = {
  key: 3,
  class: "card-loading"
}
const _hoisted_56 = { class: "photo-card-actions" }
const _hoisted_57 = ["onClick", "title"]
const _hoisted_58 = ["onClick", "title"]
const _hoisted_59 = ["onClick", "title"]
const _hoisted_60 = { class: "photo-card-info" }
const _hoisted_61 = { class: "photo-card-title" }
const _hoisted_62 = { class: "photo-card-date" }
const _hoisted_63 = {
  key: 0,
  class: "pagination-controls"
}
const _hoisted_64 = { class: "pagination-info" }
const _hoisted_65 = { class: "pagination-buttons" }
const _hoisted_66 = ["disabled", "title"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["disabled", "title"]
const _hoisted_69 = ["title"]
const _hoisted_70 = { class: "video-modal-content" }
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 1,
  class: "video-modal-info"
}
const _hoisted_73 = { class: "video-modal-title" }
const _hoisted_74 = { class: "video-modal-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUploadModal = _resolveComponent("FileUploadModal")!
  const _component_PhotoUploadModal = _resolveComponent("PhotoUploadModal")!
  const _component_PermissionGuard = _resolveComponent("PermissionGuard")!
  const _component_DocumentAnnotator = _resolveComponent("DocumentAnnotator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.photoUploading)
        ? (_openBlock(), _createBlock(_component_FileUploadModal, {
            key: 0,
            progress: $setup.photoUploadProgress,
            title: "Uploading photos..."
          }, null, 8, ["progress"]))
        : _createCommentVNode("", true),
      _createVNode(_component_PhotoUploadModal, {
        show: $setup.showUploadModal,
        "show-client-visibility-toggle": $setup.isFullManagement && !$setup.isClientUser,
        onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.showUploadModal = false)),
        onUpload: $setup.handlePhotoUpload
      }, null, 8, ["show", "show-client-visibility-toggle", "onUpload"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('projects.photoGallery')), 1),
          ($setup.photos.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('projects.photoCount', { count: $setup.photos.length })), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_PermissionGuard, { permission: 'UPLOAD_PHOTO' }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn-modern primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleUploadClick && $setup.handleUploadClick(...args)))
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("i", { class: "pi pi-cloud-upload" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.uploadPhotos')), 1)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      ($setup.photos.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "stat-header" }, [
                _createElementVNode("div", { class: "stat-icon photos" }, [
                  _createElementVNode("i", { class: "pi pi-images" })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString($setup.photos.length), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('projects.totalPhotos')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "stat-header" }, [
                _createElementVNode("div", { class: "stat-icon storage" }, [
                  _createElementVNode("i", { class: "pi pi-database" })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString($setup.totalStorageSize), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('projects.storageUsed')), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "stat-header" }, [
                _createElementVNode("div", { class: "stat-icon recent" }, [
                  _createElementVNode("i", { class: "pi pi-clock" })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_15, _toDisplayString($setup.recentPhotosCount), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('projects.recentPhotos')), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "stat-header" }, [
                _createElementVNode("div", { class: "stat-icon camera" }, [
                  _createElementVNode("i", { class: "pi pi-camera" })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_18, _toDisplayString($setup.videoCount), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('projects.videos')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.photos.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "pi pi-search search-icon" }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "search-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchQuery) = $event)),
                  placeholder: _ctx.$t('projects.searchPhotos')
                }, null, 8, _hoisted_23), [
                  [_vModelText, $setup.searchQuery]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: _normalizeClass({ active: $setup.viewMode === 'grid' }),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.viewMode = 'grid')),
                    title: _ctx.$t('projects.gridView')
                  }, [
                    _cache[24] || (_cache[24] = _createElementVNode("i", { class: "pi pi-th-large" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.grid')), 1)
                  ], 10, _hoisted_26),
                  _createElementVNode("button", {
                    class: _normalizeClass({ active: $setup.viewMode === 'masonry' }),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.viewMode = 'masonry')),
                    title: _ctx.$t('projects.masonryView')
                  }, [
                    _cache[25] || (_cache[25] = _createElementVNode("i", { class: "pi pi-table" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.masonry')), 1)
                  ], 10, _hoisted_27),
                  _createElementVNode("button", {
                    class: _normalizeClass({ active: $setup.viewMode === 'list' }),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.viewMode = 'list')),
                    title: _ctx.$t('projects.listView')
                  }, [
                    _cache[26] || (_cache[26] = _createElementVNode("i", { class: "pi pi-list" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.list')), 1)
                  ], 10, _hoisted_28)
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "sort-dropdown",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.sortBy) = $event))
                }, [
                  _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t('projects.sortNewest')), 1),
                  _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t('projects.sortOldest')), 1),
                  _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('projects.sortNameAsc')), 1),
                  _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t('projects.sortNameDesc')), 1)
                ], 512), [
                  [_vModelSelect, $setup.sortBy]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('projects.filterBy')) + ":", 1),
                _createElementVNode("button", {
                  class: _normalizeClass(["filter-tag", { active: $setup.mediaFilter === 'all' }]),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.mediaFilter = 'all'))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.all')), 1),
                  _createElementVNode("span", _hoisted_36, _toDisplayString($setup.photos.length), 1)
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["filter-tag", { active: $setup.mediaFilter === 'images' }]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.mediaFilter = 'images'))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.images')), 1),
                  _createElementVNode("span", _hoisted_37, _toDisplayString($setup.imageCount), 1)
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["filter-tag", { active: $setup.mediaFilter === 'videos' }]),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.mediaFilter = 'videos'))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.videos')), 1),
                  _createElementVNode("span", _hoisted_38, _toDisplayString($setup.videoCount), 1)
                ], 2)
              ]),
              ($setup.totalPages > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('common.pagination.showing')) + " " + _toDisplayString($setup.paginationInfo.start) + "-" + _toDisplayString($setup.paginationInfo.end) + " " + _toDisplayString(_ctx.$t('common.of')) + " " + _toDisplayString($setup.paginationInfo.total), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("button", {
                        class: "pagination-btn",
                        disabled: $setup.currentPage === 1,
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        title: _ctx.$t('common.previous')
                      }, [...(_cache[27] || (_cache[27] = [
                        _createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
                      ]))], 8, _hoisted_42),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.totalPages, (page) => {
                        return _withDirectives((_openBlock(), _createElementBlock("button", {
                          key: page,
                          class: _normalizeClass(["pagination-btn page-number", { active: $setup.currentPage === page }]),
                          onClick: ($event: any) => ($setup.goToPage(page))
                        }, _toDisplayString(page), 11, _hoisted_43)), [
                          [_vShow, page === 1 || page === $setup.totalPages || Math.abs(page - $setup.currentPage) <= 2]
                        ])
                      }), 128)),
                      _createElementVNode("button", {
                        class: "pagination-btn",
                        disabled: $setup.currentPage === $setup.totalPages,
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        title: _ctx.$t('common.next')
                      }, [...(_cache[28] || (_cache[28] = [
                        _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)
                      ]))], 8, _hoisted_44)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                return _createElementVNode("div", {
                  class: "skeleton-item",
                  key: n
                }, [...(_cache[29] || (_cache[29] = [
                  _createElementVNode("div", { class: "skeleton-image" }, null, -1),
                  _createElementVNode("div", { class: "skeleton-text" }, null, -1),
                  _createElementVNode("div", { class: "skeleton-text short" }, null, -1)
                ]))])
              }), 64))
            ])
          ]))
        : ($setup.photos.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"empty-illustration\" data-v-266e3fa8><div class=\"empty-circle\" data-v-266e3fa8><i class=\"pi pi-camera\" data-v-266e3fa8></i></div><div class=\"empty-circles\" data-v-266e3fa8><div class=\"circle circle-1\" data-v-266e3fa8></div><div class=\"circle circle-2\" data-v-266e3fa8></div><div class=\"circle circle-3\" data-v-266e3fa8></div></div></div>", 1)),
              _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.$t('projects.noPhotosAvailable')), 1),
              _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('projects.noPhotosAvailableDescription')), 1),
              _createElementVNode("button", {
                class: "btn-modern primary",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.handleUploadClick && $setup.handleUploadClick(...args)))
              }, [
                _cache[30] || (_cache[30] = _createElementVNode("i", { class: "pi pi-plus" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.addFirstPhoto')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 5,
              class: _normalizeClass(["gallery-container", $setup.viewMode])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["photo-grid", $setup.viewMode])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedPhotos, (photo) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: photo.id,
                    class: _normalizeClass(["photo-card", { 'is-video': photo.isVideo }]),
                    onClick: ($event: any) => (photo.isVideo ? $setup.playVideo($event, photo) : $setup.zoomPhoto($event, photo))
                  }, [
                    _createElementVNode("div", _hoisted_51, [
                      (!photo.isVideo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: photo.secureUrl || $setup.PLACEHOLDER_SVG,
                            alt: photo.fileName || 'Photo',
                            class: _normalizeClass(["card-image zoom-image", { 'loading': !photo.loaded }]),
                            onLoad: ($event: any) => ($setup.onImageLoad(photo)),
                            onError: ($event: any) => ($setup.onImageError(photo))
                          }, null, 42, _hoisted_52))
                        : (_openBlock(), _createElementBlock("video", {
                            key: 1,
                            src: photo.secureUrl || '',
                            class: _normalizeClass(["card-video", { 'loading': !photo.loaded }]),
                            muted: "",
                            playsinline: "",
                            preload: "metadata",
                            onLoadeddata: ($event: any) => ($setup.onVideoLoad(photo)),
                            onError: ($event: any) => ($setup.onVideoError(photo))
                          }, null, 42, _hoisted_53)),
                      (photo.isVideo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [...(_cache[32] || (_cache[32] = [
                            _createElementVNode("i", { class: "pi pi-play" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (!photo.loaded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [...(_cache[33] || (_cache[33] = [
                            _createElementVNode("div", { class: "loading-pulse" }, [
                              _createElementVNode("div", { class: "pulse-ring" }),
                              _createElementVNode("div", { class: "pulse-ring" }),
                              _createElementVNode("div", { class: "pulse-ring" })
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "photo-overlay" }, null, -1)),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("button", {
                          class: "action-btn download",
                          onClick: _withModifiers(($event: any) => ($setup.downloadPhoto(photo)), ["stop"]),
                          title: _ctx.$t('common.download')
                        }, [...(_cache[34] || (_cache[34] = [
                          _createElementVNode("i", { class: "pi pi-download" }, null, -1)
                        ]))], 8, _hoisted_57),
                        _createVNode(_component_PermissionGuard, { permission: 'UPLOAD_PHOTO' }, {
                          default: _withCtx(() => [
                            (!photo.isVideo)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "action-btn annotate",
                                  onClick: _withModifiers(($event: any) => ($setup.annotatePhoto(photo)), ["stop"]),
                                  title: _ctx.$t('common.annotate')
                                }, [...(_cache[35] || (_cache[35] = [
                                  _createElementVNode("i", { class: "pi pi-pencil" }, null, -1)
                                ]))], 8, _hoisted_58))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_PermissionGuard, { permission: 'DELETE_PHOTO' }, {
                          default: _withCtx(() => [
                            ($setup.canDeletePhoto(photo))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "action-btn delete",
                                  onClick: _withModifiers(($event: any) => ($setup.deletePhoto(photo)), ["stop"]),
                                  title: _ctx.$t('common.delete')
                                }, [...(_cache[36] || (_cache[36] = [
                                  _createElementVNode("i", { class: "pi pi-trash" }, null, -1)
                                ]))], 8, _hoisted_59))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("h4", _hoisted_61, _toDisplayString(photo.fileName || photo.originalName || 'Photo'), 1),
                      _createElementVNode("p", _hoisted_62, [
                        _cache[38] || (_cache[38] = _createElementVNode("i", { class: "pi pi-calendar" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString($setup.formatDate(photo.createdAt)), 1)
                      ])
                    ])
                  ], 10, _hoisted_50))
                }), 128))
              ], 2),
              ($setup.viewMode !== 'gallery' && $setup.totalPages > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('common.pagination.showing')) + " " + _toDisplayString($setup.paginationInfo.start) + "-" + _toDisplayString($setup.paginationInfo.end) + " " + _toDisplayString(_ctx.$t('common.of')) + " " + _toDisplayString($setup.paginationInfo.total), 1),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("button", {
                        class: "pagination-btn",
                        disabled: $setup.currentPage === 1,
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        title: _ctx.$t('common.previous')
                      }, [...(_cache[39] || (_cache[39] = [
                        _createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
                      ]))], 8, _hoisted_66),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.totalPages, (page) => {
                        return _withDirectives((_openBlock(), _createElementBlock("button", {
                          key: page,
                          class: _normalizeClass(["pagination-btn page-number", { active: $setup.currentPage === page }]),
                          onClick: ($event: any) => ($setup.goToPage(page))
                        }, _toDisplayString(page), 11, _hoisted_67)), [
                          [_vShow, page === 1 || page === $setup.totalPages || Math.abs(page - $setup.currentPage) <= 2]
                        ])
                      }), 128)),
                      _createElementVNode("button", {
                        class: "pagination-btn",
                        disabled: $setup.currentPage === $setup.totalPages,
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        title: _ctx.$t('common.next')
                      }, [...(_cache[40] || (_cache[40] = [
                        _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)
                      ]))], 8, _hoisted_68)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.showPhotoAnnotator && $setup.selectedPhotoForAnnotation && $setup.photoAnnotatorUrl && $props.projectId)
        ? (_openBlock(), _createBlock(_component_DocumentAnnotator, {
            key: 0,
            projectId: Number($props.projectId),
            documentId: Number($setup.selectedPhotoForAnnotation?.id),
            documentUrl: $setup.photoAnnotatorUrl,
            fileName: $setup.selectedPhotoForAnnotation?.fileName || $setup.selectedPhotoForAnnotation?.originalName || $setup.selectedPhotoForAnnotation?.name || 'Photo',
            fileType: $setup.getFileType($setup.selectedPhotoForAnnotation),
            onClose: $setup.closePhotoAnnotator,
            onSaved: $setup.handleAnnotationSaved
          }, null, 8, ["projectId", "documentId", "documentUrl", "fileName", "fileType", "onClose", "onSaved"]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.showVideoModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "video-modal-overlay",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.closeVideoModal && $setup.closeVideoModal(...args)))
          }, [
            _createElementVNode("div", {
              class: "video-modal-container",
              onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("button", {
                class: "video-modal-close",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.closeVideoModal && $setup.closeVideoModal(...args))),
                title: _ctx.$t('common.close')
              }, [...(_cache[41] || (_cache[41] = [
                _createElementVNode("i", { class: "pi pi-times" }, null, -1)
              ]))], 8, _hoisted_69),
              _createElementVNode("div", _hoisted_70, [
                ($setup.selectedVideo)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 0,
                      src: $setup.selectedVideo.secureUrl || '',
                      class: "video-modal-player",
                      controls: "",
                      autoplay: "",
                      playsinline: ""
                    }, null, 8, _hoisted_71))
                  : _createCommentVNode("", true),
                ($setup.selectedVideo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("h3", _hoisted_73, _toDisplayString($setup.selectedVideo.fileName || $setup.selectedVideo.originalName || 'Video'), 1),
                      _createElementVNode("p", _hoisted_74, _toDisplayString($setup.formatDate($setup.selectedVideo.createdAt)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}